import classNames from 'clsx';
import debounce from 'lodash/debounce';
import Router from 'next/router';
import React from 'react';
import Tab from 'react-bootstrap/lib/Tab';
import Tabs from 'react-bootstrap/lib/Tabs';
import {
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  injectStripe,
} from 'react-stripe-elements';
import { loadStripe } from '@stripe/stripe-js';
import { reduxForm } from 'redux-form';
import { i18n } from 'next-i18next';
import { withI18next } from '~/../hocs/_withI18next';
import Link from '~/components/I18nLink';
import Config from '~/config';
import * as premiumService from '~/services/Premium';
import I18nRouter from '~/components/I18nRouter';

// TODO: Refactor this style
const createOptions = {
  style: {
    base: {
      fontSize: '18px',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#8f9ba5',
      },
    },
    invalid: {
      color: '#b90000',
    },
  },
};

const styles = {
  iconLoading: {
    fontSize: 22,
  },
  iconSecure: {
    fontSize: 18,
    marginBottom: 2,
  },
};

const renderCheckboxField = ({ input, placeholder, type, title }) => (
  <label style={{ marginTop: 5, paddingRight: 5 }}>
    <input type={type} {...input} />
    <b style={{ borderRadius: 2 }} /> {title}
  </label>
);

const PAYMENT_METHODS = {
  CARD: 'card',
  ALIPAY: 'alipay',
  WECHAT: 'wechat',
};

@withI18next()
class PaymentSingleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardElement: null,
      errorCardNumber: null,
      errorExpiry: null,
      errorCVC: null,
      errorToken: '',
      modal: false,
      subscribing: false,
      selectedMethod: PAYMENT_METHODS.WECHAT,
      paymentIntent: {},
      // stripe: null,
      wechat: {
        active: false,
        qrcodeURL: null,
      },
      alipay: {
        redirecting: false,
      },
      stripeChina: null,
    };
    this.onSubmit = debounce(this.onSubmit, 500);
    this.premiumService = premiumService;
    this.timerHandle = null;
  }

  async componentDidMount() {
    if (process.browser) {
      // const stripe = window.Stripe(Config.stripePublicKey[Config.serviceType]);
      const stripeChina = await loadStripe(
        Config.stripePublicKey[Config.serviceType],
      );

      this.setState({ stripeChina });
      // this.idempotencyTokenInterval = setInterval(() => {
      //   this.idempotencyToken = uuidv4();
      // }, 5000);
    }
  }

  // componentWillUnmount() {
  //   clearInterval(this.idempotencyTokenInterval);
  // }

  handleChange = (change) => {
    const { elementType, error } = change;
    switch (elementType) {
      case 'cardNumber':
        this.setState({ errorCardNumber: error ? error.message : '' });
        break;
      case 'cardExpiry':
        this.setState({ errorExpiry: error ? error.message : '' });
        break;
      case 'cardCvc':
        this.setState({ errorCVC: error ? error.message : '' });
        break;
      default:
        break;
    }
  };

  handleReady = (element) => {
    this.setState({
      cardElement: element,
    });
  };

  onSubmit = async () => {
    const {
      stripe,
      onSubmit,
      paymentIntent,
      showLoadingFullScreenCard,
      closeModal,
    } = this.props;
    const result = await stripe.createToken();
    console.log('onSubmit CARDDDDDDD', result);
    if (result.error) {
      const { code, message } = result.error;
      this.setState({
        errorCardNumber: code.includes('number') ? message : '',
        errorExpiry: code.includes('expiry') ? message : '',
        errorCVC: code.includes('cvc') ? message : '',
        errorToken: code.includes('card_declined') ? message : '',
        subscribing: false,
      });
    } else {
      closeModal();
      showLoadingFullScreenCard();
      const { client_secret } = paymentIntent;
      const response = await stripe.handleCardPayment(client_secret, {
        payment_method_data: {
          card: {
            token: result.token.id,
          },
        },
      });
      this.handlePaymentIntent(response.paymentIntent, PAYMENT_METHODS.CARD);
    }
  };

  handleSubscribe = (e) => {
    e.preventDefault();
    const { handleSubmit } = this.props;
    handleSubmit(this.onSubmit)();
  };

  renderInputError = (inputError) => {
    const containerClassName = classNames(
      'error-messages',
      inputError && 'show-message',
    );
    return (
      <div className={containerClassName}>
        {inputError && (
          <div className="text-center" style={{ marginTop: '-7px' }}>
            <div
              className={`${Config.getPrefixContent(
                'arrow-up',
              )} arrow-up display-inline-block`}
            />
            <div
              className={`${Config.getPrefixContent(
                'bg-yellow',
              )} field-message-error animated`}
              style={{ marginTop: '-5px' }}
            >
              {inputError}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderAlipayButton = () => {
    const { paymentIntent } = this.props;
    if (this.props.paymentIntent) {
      if (this.state.alipay.redirecting) {
        return <span>{this.props.t('redirecting_text')}</span>;
      }
      return <span>{this.props.t('pay_with_alipay')}</span>;
    }
    return <span>{this.props.t('loading_text')}</span>;
  };

  renderAlipayPaymentMethod = () => (
    <div className="payment-method-content alipay">
      <p>{this.props.t('redirect_to_alipay_payment')}</p>
      <button
        className={`btn btn-ac-primary btn-${Config.serviceType} btn-payment`}
        onClick={(e) => {
          this.handlePaymentOneTime(e, PAYMENT_METHODS.ALIPAY);
        }}
        disabled={!this.props.paymentIntent}
      >
        {this.renderAlipayButton()}
      </button>
      <p>{this.props.t('user_agree_term')}</p>
      <Link href="/terms-premium">
        <a className={`color-${Config.serviceType}`}>
          {this.props.t(
            Config.getPrefixContent('register_premium_card_number_content4'),
          )}
        </a>
      </Link>
      <Link href="/privacy-policy">
        <a className={`color-${Config.serviceType}`}>
          {this.props.t('register_premium_card_number_content5')}
        </a>
      </Link>
    </div>
  );

  handleClickWechatPayment = async (e) => {
    const scroll = await import('react-scroll');
    this.handlePaymentOneTime(e, PAYMENT_METHODS.WECHAT);
    scroll.animateScroll.scrollToTop({
      delay: 100,
      smooth: true,
    });
  };

  renderWechatPaymentMethod = () => (
    <div className="payment-method-content wechat">
      <p>{this.props.t('click_button_generate_qr_code')}</p>
      <button
        className={`btn btn-ac-primary btn-${Config.serviceType} btn-payment`}
        onClick={this.handleClickWechatPayment}
        disabled={!this.props.paymentIntent}
      >
        {this.props.paymentIntent ? (
          <span>{this.props.t('generate_qr_code')}</span>
        ) : (
          <span>{this.props.t('loading_text')}</span>
        )}
      </button>
      <p>{this.props.t('user_agree_term')}</p>
      <Link href="/terms-premium">
        <a className={`color-${Config.serviceType}`}>
          {this.props.t(
            Config.getPrefixContent('register_premium_card_number_content4'),
          )}
        </a>
      </Link>
      <Link href="/privacy-policy">
        <a className={`color-${Config.serviceType}`}>
          {this.props.t('register_premium_card_number_content5')}
        </a>
      </Link>
    </div>
  );

  renderCardPaymentMethodForOneTimePayment = () => {
    const {
      pristine,
      handleSubmit,
      submitting,
      messageError,
      agree,
      disable,
      t,
    } = this.props;
    const {
      errorCardNumber,
      errorExpiry,
      errorCVC,
      errorToken,
      subscribing,
    } = this.state;
    const isNew =
      errorCardNumber === null || errorExpiry === null || errorCVC === null;
    const haveError = errorCardNumber || errorExpiry || errorCVC;
    return (
      <form>
        <div className="payment-method-content-card">
          <div className="padding-10 pb30 credit-card-stripe">
            <div style={{ position: 'relative' }} className="pt15">
              <label className="pb5">{t('register_premium_card_number')}</label>
              <CardNumberElement
                className="bg-input-credit"
                onChange={this.handleChange}
                {...createOptions}
              />
              {this.renderInputError(errorCardNumber)}
            </div>
            <div style={{ position: 'relative' }} className="pt15">
              <label className="pb5">
                {t('register_premium_expiration_date')}
              </label>
              <CardExpiryElement
                className="bg-input-credit"
                onChange={this.handleChange}
                {...createOptions}
              />
              {this.renderInputError(errorExpiry)}
            </div>
            <div style={{ position: 'relative' }} className="pt15">
              <label className="pb5">CVC</label>
              <CardCVCElement
                className="bg-input-credit"
                onChange={this.handleChange}
                {...createOptions}
              />
              {this.renderInputError(errorCVC)}
            </div>
          </div>
          <p>{this.props.t('user_agree_term')}</p>
          <div className="padding-10" style={{ textAlign: 'center' }}>
            <div>
              <Link href="/terms-premium">
                <a className={`color-${Config.serviceType}`}>
                  {t(
                    Config.getPrefixContent(
                      'register_premium_card_number_content4',
                    ),
                  )}
                </a>
              </Link>
              <br />
              <Link href="/privacy-policy">
                <a className={`color-${Config.serviceType}`}>
                  {t('register_premium_card_number_content5')}
                </a>
              </Link>
            </div>
          </div>
          <div className="pb30 text-center">
            <button
              className={`btn btn-ac-primary btn-${Config.serviceType} btn-payment`}
              onClick={this.handleSubscribe}
              disabled={submitting || !this.props.paymentIntent}
            >
              {this.props.paymentIntent ? (
                <span> {t('credit_premium_benefit_button2')}</span>
              ) : (
                <span>{this.props.t('loading_text')}</span>
              )}
            </button>
          </div>
        </div>
      </form>
    );
  };

  renderPaymentSingleMethods = () => (
    <div className="payment-methods-container">
      <Tabs
        defaultActiveKey={this.state.selectedMethod}
        className={`payment-methods ${Config.serviceType}`}
        justified
        transition
      >
        <Tab id="Card" eventKey={PAYMENT_METHODS.CARD} title="Card">
          {this.renderCardPaymentMethodForOneTimePayment()}
        </Tab>
        <Tab id="Alipay" eventKey={PAYMENT_METHODS.ALIPAY} title="Alipay">
          {this.renderAlipayPaymentMethod()}
        </Tab>
        <Tab id="Wechat" eventKey={PAYMENT_METHODS.WECHAT} title="Wechat">
          {this.renderWechatPaymentMethod()}
        </Tab>
      </Tabs>
    </div>
  );

  handlePaymentOneTime = async (e, typeOfPayment) => {
    e.preventDefault();
    const { stripe } = this.props;
    const { id, amount, currency } = this.props.paymentIntent;
    const { stripeChina } = this.state;
    const sourceData = {
      type: typeOfPayment,
      amount,
      currency,
      redirect: {
        return_url: `${Config.getSiteURL()}/premium-payment-infor`,
      },
      metadata: {
        paymentIntent: id,
      },
    };
    console.log('handlePaymentOneTimeeeee', sourceData);
    console.log('stripe luc nay', stripeChina);
    let source;
    try {
      source = await stripeChina.createSource(sourceData);
      source = source?.source || null;
      console.log('siyasdasdasd', source);
    } catch (e) {
      console.log('loi ne', e);
    }
    console.log('sourceeeeeeeeeeeeeee', source.flow);
    switch (source.flow) {
      case 'none':
        if (source.type === PAYMENT_METHODS.WECHAT) {
          this.props.closeModal();
          this.props.showLoadingFullScreenWeChat({
            result: false,
            qrCodeURL: source.wechat.qr_code_url,
          });
          this.pollPaymentIntentStatus(PAYMENT_METHODS.WECHAT);
        }
        break;
      case 'redirect':
        if (source.type === PAYMENT_METHODS.ALIPAY) {
          this.setState(
            {
              alipay: {
                redirecting: true,
              },
            },
            () => {
              window.location.replace(source.redirect.url);
            },
          );
        }
        break;
    }
  };

  pollPaymentIntentStatus = (paymentMethod) => {
    const {
      initPollingPaymentIntentStatus,
      stopPollingPaymentIntentStatus,
    } = this.props;
    const start = Date.now();
    const timeout = 1200000;
    const endStates = ['succeeded', 'processing', 'canceled'];
    initPollingPaymentIntentStatus(
      setInterval(() => {
        this.premiumService
          .getCurrentPaymentIntent(this.props.paymentIntent.id)
          .then((rs) => {
            if (endStates.includes(rs.status) || Date.now() > start + timeout) {
              stopPollingPaymentIntentStatus();
              this.handlePaymentIntent(rs, paymentMethod);
            }
          });
      }, 1000),
    );
  };

  handlePaymentIntent = (paymentIntent, paymentMethod) => {
    if (paymentMethod === PAYMENT_METHODS.WECHAT) {
      if (paymentIntent && paymentIntent.status === 'succeeded') {
        this.props.hideLoadingFullScreen();
        this.props.updateProfile(this.props.lng);
        I18nRouter.push(
          '/register-premium-success',
          '/register-premium/success',
        );
      } else {
        this.props.hideLoadingFullScreen();
        this.props.showError({
          error: 'registering_premium_failed',
          title: i18n.t('registering_premium_wechat_failed_title'),
          description: i18n.t('registering_premium_wechat_failed_description'),
        });
      }
    }

    if (paymentMethod === PAYMENT_METHODS.CARD) {
      if (paymentIntent && paymentIntent.status === 'succeeded') {
        this.props.hideLoadingFullScreen();
        this.props.updateProfile(this.props.lng);
        I18nRouter.push(
          '/register-premium-success',
          '/register-premium/success',
        );
      } else {
        this.props.hideLoadingFullScreen();
        this.props.showError({
          error: 'registering_premium_failed',
          title: i18n.t('registering_premium_failed'),
        });
      }
    }
  };

  render() {
    const { t } = this.props;

    return (
      <div className="register-premium-form">
        <div
          className="credit-card-infor"
          style={{
            display: 'flex',
            paddingBottom: 30,
            alignItems: 'center',
          }}
        >
          {this.renderPaymentSingleMethods()}
        </div>

        <ul className="secure-notes">
          <li className="secure-note-item">
            {t('register_premium_card_number_content6')}
          </li>
          <li className="secure-note-item">
            {t('register_premium_card_number_content9')}
          </li>
        </ul>
        <style jsx global>
          {`
            @charset "UTF-8";
            .payment-modal .social-section {
              background: #ffffff;
              text-align: center;
            }

            .payment-modal .login-section {
              padding: 20px 55px 30px;
            }

            .btn-payment {
              margin: auto;
              text-align: center;
              margin-bottom: 10px;
              padding: 10px;
            }

            @media (max-width: 768px) {
              .payment-modal .ac-dialog {
                width: calc(100% - 20px);
                margin-left: 10px;
                margin-right: 10px;
              }
            }

            .responsive-login-modal {
              text-align: center;
            }

            .register-premium-form {
              padding: 10px;
            }
            .register-premium-form .payment-methods-container {
              width: 100%;
            }
            .register-premium-form .payment-methods-container .payment-methods {
              margin: 0 auto;
              margin-top: 5px;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li
              a {
              color: #1b2833;
              font-weight: 800;
              font-size: 14px;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li
              a,
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li
              a:hover,
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li
              a:active,
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li
              a:focus {
              border: none;
              background-color: transparent;
              border-bottom: 2px solid transparent;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li {
              padding-bottom: 3px;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li.active
              a,
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li.active
              a:hover,
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li.active
              a:active,
            .register-premium-form
              .payment-methods-container
              .payment-methods
              ul
              li.active
              a:focus {
              border: none;
              padding-bottom: 4px !important;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods.photo_ac
              ul
              li.active
              a,
            .register-premium-form
              .payment-methods-container
              .payment-methods.photo_ac
              ul
              li.active
              a:hover,
            .register-premium-form
              .payment-methods-container
              .payment-methods.photo_ac
              ul
              li.active
              a:active,
            .register-premium-form
              .payment-methods-container
              .payment-methods.photo_ac
              ul
              li.active
              a:focus {
              border-bottom: 2px solid #509bdc;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods.illust_ac
              ul
              li.active
              a,
            .register-premium-form
              .payment-methods-container
              .payment-methods.illust_ac
              ul
              li.active
              a:hover,
            .register-premium-form
              .payment-methods-container
              .payment-methods.illust_ac
              ul
              li.active
              a:active,
            .register-premium-form
              .payment-methods-container
              .payment-methods.illust_ac
              ul
              li.active
              a:focus {
              border-bottom: 2px solid #d73a4e;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods.silhouette_ac
              ul
              li.active
              a,
            .register-premium-form
              .payment-methods-container
              .payment-methods.silhouette_ac
              ul
              li.active
              a:hover,
            .register-premium-form
              .payment-methods-container
              .payment-methods.silhouette_ac
              ul
              li.active
              a:active,
            .register-premium-form
              .payment-methods-container
              .payment-methods.silhouette_ac
              ul
              li.active
              a:focus {
              border-bottom: 2px solid #41b9b8;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods.design_ac
              ul
              li.active
              a,
            .register-premium-form
              .payment-methods-container
              .payment-methods.design_ac
              ul
              li.active
              a:hover,
            .register-premium-form
              .payment-methods-container
              .payment-methods.design_ac
              ul
              li.active
              a:active,
            .register-premium-form
              .payment-methods-container
              .payment-methods.design_ac
              ul
              li.active
              a:focus {
              border-bottom: 2px solid #ffa823;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              .payment-method-content {
              padding: 20px 0px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              background: white;
              border-color: #e5edef;
              border-image: initial;
              border-radius: 2px;
              box-shadow: 0 1px 5px rgba(134, 159, 178, 0.6);
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              .payment-method-content.wechat
              .wechat-qrcode {
              margin-bottom: 20px;
              margin-top: 10px;
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              .payment-method-content-card {
              padding: 20px 0px;
              background: white;
              border-color: #e5edef;
              border-radius: 2px;
              box-shadow: 0 1px 5px rgba(134, 159, 178, 0.6);
            }
            .register-premium-form
              .payment-methods-container
              .payment-methods
              .payment-method-content-card
              .bg-input-credit {
              background: #f2f3f4;
            }
            .register-premium-form .secure-notes {
              padding: 30px 10px;
              text-align: left;
              list-style: none;
            }
            .register-premium-form .secure-notes .secure-note-item {
              margin-top: 7px;
            }
            .register-premium-form .secure-notes .secure-note-item:before {
              content: '🔏';
            }
          `}
        </style>
      </div>
    );
  }
}

let registerPremiumSingleForm = reduxForm({
  form: 'PaymentSingleForm',
})(PaymentSingleForm);
registerPremiumSingleForm = injectStripe(registerPremiumSingleForm);

export default registerPremiumSingleForm;
